import React from 'react'
import moment from 'moment';
import { Grid } from "@mui/material";
import {
    DataGrid,
} from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';

// Components
import CMLabel from '../../components/atoms/CMLabel';
import CMDatePicker from '../../components/molecules/CMDatePicker';
import CMButton from '../../components/atoms/CMButton';
import CMIconButton from '../../components/atoms/CMIconButton';

// Constants
import { MomentLocaleEs } from '../../constants/MomentLocaleEs';

// Services
import * as GerenciaService from '../../services/GerenciaService';

const OrdenesPendientesAprobar = () => {
    const [rowsdata, setRowsdata] = useState([]);
    const [rowsexcel, setRowsexcel] = useState([]);
    const [fechaInicio, setFechaInicio] = useState(moment().locale('es', MomentLocaleEs).subtract(10, 'days'));
    const [fechaFin, setFechaFin] = useState(moment().locale('es', MomentLocaleEs));
    const user = JSON.parse(window.localStorage.getItem("user"));
    const [loading, setLoading] = useState(true);
    const [btndisabled, setBtndisabled] = useState(true);

    // ── NUEVO: filas seleccionadas ──────────────────────────────────────────────
    const [selectedRows, setSelectedRows] = useState([]);       // ids seleccionados
    const [aprobandoMasivo, setAprobandoMasivo] = useState(false);

    const history = useHistory();

    // Agrega esto temporalmente en OrdenesPendientesAprobar, arriba del useEffect


    useEffect(() => {
    const dataList = {
        "id_usuario": user.id_usuario,
        "from_date": fechaInicio,
        "to_date": fechaFin
    };
    GerenciaService.getOrdenesPendienteAprobacion(dataList, setRowsdata, user.token, setLoading);
}, []);


    const updateOrdenes = () => {
    const dataList = {
        "id_usuario": user.id_usuario,
        "from_date": fechaInicio,
        "to_date": fechaFin
    };
    setLoading(true);
    setSelectedRows([]);
    GerenciaService.getOrdenesPendienteAprobacion(dataList, setRowsdata, user.token, setLoading);
};

    // ── NUEVO: aprobar masivamente ──────────────────────────────────────────────
    const handleAprobarMasivo = async () => {
        const { value: comentario, isConfirmed } = await Swal.fire({
            title: `Aprobar ${selectedRows.length} órdenes`,
            html: `
                <p style="margin-bottom:10px;font-size:14px;color:#555;">
                    Se aprobarán <b>${selectedRows.length}</b> órdenes seleccionadas.
                </p>
                <input 
                    id="swal-comentario" 
                    class="swal2-input" 
                    placeholder="Comentario (opcional)"
                    style="width:90%"
                />
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aprobar todas',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return document.getElementById('swal-comentario').value || '';
            }
        });

        if (!isConfirmed) return;

        // Armar el payload: solo los campos que necesita el backend
        const payload = selectedRows.map(id => {
    const oc = rowsdata.find(r => r.id_oc_cabecera === id);
    return {
        ...oc,                                        // todos los campos de la OC
        id_aprobador_gerencia: user.id_usuario,       // sobreescribir con el usuario actual
        comentario: comentario,                       // sobreescribir con el comentario del modal
    };
});

        setAprobandoMasivo(true);
        try {
            await GerenciaService.aprobarGerenciaMasiva(payload, user.token);
            Swal.fire({
                title: `¡${selectedRows.length} órdenes aprobadas!`,
                icon: 'success',
                confirmButtonText: 'OK'
            }).then(() => {
                setSelectedRows([]);
                updateOrdenes();
            });
        } catch (error) {
            Swal.fire('Error', 'Ocurrió un error al aprobar las órdenes.', 'error');
        } finally {
            setAprobandoMasivo(false);
        }
    };

    const formatCurrency = (value, moneda) => {
        const currency = moneda === 'US$' ? 'USD' : 'PEN';
        return value.toLocaleString('es-PE', { style: 'currency', currency });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const exportToExcel = async () => {
    setBtndisabled(true);
    const dataList = {
        "id_usuario": user.id_usuario,
        "from_date": fechaInicio,
        "to_date": fechaFin
    };
    await GerenciaService.getOrdenesPendienteAprobacionExcel(dataList, setRowsexcel, user.token, setBtndisabled);
    
        const headers = ['ID','Proveedor','Nombre Solicitante','Tipo','Observaciones','Estado','Nombre Estado','Destino','Condición Pago','Fecha Creación','Fecha Documento','Fecha Contable','Fecha Entrega','Moneda','Impuesto','Sub Total','importe total','ID OC Detalle','Fecha Entrega Detalle','Descripción','Código Artículo','Cantidad Pedida','Cantidad Entregada','Cantidad Recibida','Precio Unitario','Porcentaje Descuento','Total Artículo','Unidad Medida'];
        const data = [
            headers,
            ...rowsexcel.flatMap(item =>
                item.oc_detalles.map(detalle => [
                    item.id, item.nombre_proveedor, item.nombre_solicitante, item.tipo,
                    item.observaciones, item.estado, item.ultimo_nombre_oc_estado,
                    item.destino, item.condic_pago,
                    formatDate(item.fecha_registro), formatDate(item.fecha_documento),
                    formatDate(item.fecha_contable), formatDate(item.fecha_entrega),
                    item.moneda, item.impuesto, item.total_antes_descuento, item.total_pago_vencido,
                    detalle.id_oc_detalle, formatDate(detalle.fecha_entrega),
                    detalle.descripcion, detalle.codigo_articulo, detalle.cantidad_pedida,
                    detalle.cantidad_entregada, detalle.cantidad_recibida,
                    detalle.precio_unitario, detalle.porcentaje_descuento,
                    detalle.total_articulo, detalle.unidad_medida
                ])
            )
        ];
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'OrdenesPendientesAprobar');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'OrdenesPendientesAprobarGerencia.xlsx';
        link.click();
    };

    const columns = [
        {
            field: "ver", headerName: "Ver", width: 50,
            renderCell: (cellValues) => (
                <CMIconButton onClick={() => { history.push(`/ordenespendientesaprobaciongerencia/${cellValues.row.id_oc_cabecera}`); history.go(0); }}>
                    <VisibilityIcon />
                </CMIconButton>
            )
        },
        {
            field: 'Id', headerName: 'Id', type: 'text', width: 150,
            valueGetter: (params) => params.row.id_documento_borrador === null || params.row.id_documento_borrador === '' ? '000' + params.row.id_oc_cabecera : params.row.id_documento_borrador,
        },
        { field: 'ruc_proveedor', headerName: 'RUC', width: 120 },
        { field: 'nombre_proveedor', headerName: 'Nombre Proveedor', width: 300 },
        { field: 'nombre_solicitante', headerName: 'Nombre Solicitante', width: 150 },
        { field: 'observaciones', headerName: 'Observaciones', width: 450 },
        { field: 'motivo_solicitud', headerName: 'Motivo Solicitud', width: 450 },
        { field: 'total_antes_descuento', headerName: 'Sub Total', width: 160, valueGetter: (params) => formatCurrency(params.row.total_antes_descuento, params.row.moneda) },
        { field: 'impuesto', headerName: 'Impuesto', width: 160, valueGetter: (params) => formatCurrency(params.row.impuesto, params.row.moneda) },
        { field: 'total_pago_vencido', headerName: 'Importe Total', width: 160, valueGetter: (params) => formatCurrency(params.row.total_pago_vencido, params.row.moneda) },
        { field: 'ultimo_nombre_oc_estado', headerName: 'Nombre Estado', width: 290 },
        { field: 'estado', headerName: 'Estado', width: 120 },
        { field: 'tipo', headerName: 'Tipo', width: 150 },
        { field: 'destino', headerName: 'Destino', width: 350 },
        { field: 'condic_pago', headerName: 'Condición Pago', width: 150 },
        { field: 'fecha_registro', headerName: 'Fecha Creación', width: 150, valueGetter: (params) => moment(params.value).format('DD-MM-YYYY') },
        { field: 'fecha_documento', headerName: 'Fecha Documento', width: 150, valueGetter: (params) => moment(params.value).format('DD-MM-YYYY') },
        { field: 'fecha_contable', headerName: 'Fecha Contable', width: 150, valueGetter: (params) => moment(params.value).format('DD-MM-YYYY') },
        { field: 'fecha_entrega', headerName: 'Fecha Entrega', width: 150, valueGetter: (params) => moment(params.value).format('DD-MM-YYYY') },
    ];

    return (
        <Grid width={'100%'} m="auto">
            <Grid container justifyContent="flex-start" alignItems="center" spacing={2} sx={{ py: 1 }}>

                <Grid container item xs={12} sm={12}>
                    <Grid item sm={6}>
                        <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">
                            <b>Ordenes Pendiente de Aprobación Gerencia</b>
                        </CMLabel>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} justifyContent="center">
                    <Grid item sm={12}>
                        <hr /><br />
                        <Grid container item xs={12} sm={12} alignItems="center">
                            <Grid item xs={12} sm={1.5}>
                                <CMLabel fontSize='14px' color='black'>Fecha inicio creación: </CMLabel>
                            </Grid>
                            <Grid item xs={12} sm={1.5}>
                                <CMDatePicker label="Desde" value={fechaInicio} onChange={(newDate) => setFechaInicio(newDate)} readOnly={false} fullWidth disabled={false} />
                            </Grid>
                            <Grid item xs={12} sm={0.2} />
                            <Grid item xs={12} sm={1.2}>
                                <CMLabel fontSize='14px' color='black' sx={{ marginLeft: '10px' }}>Fecha fin creación: </CMLabel>
                            </Grid>
                            <Grid item xs={12} sm={0.2} />
                            <Grid item xs={12} sm={1.5}>
                                <CMDatePicker label="Hasta" value={fechaFin} onChange={(newDate) => setFechaFin(newDate)} readOnly={false} fullWidth disabled={false} />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <CMButton label="Consultar" variant="contained" sx={{ marginLeft: '10px', marginTop: '10px' }} onClick={updateOrdenes} />
                            </Grid>
                            <Grid item xs={12} sm={1.5}>
                                <CMButton label="Exportar" variant="contained" sx={{ marginLeft: '10px', marginTop: '10px' }} disabled={btndisabled} onClick={exportToExcel} />
                            </Grid>

                            {/* ── NUEVO BOTÓN APROBAR MASIVO ── */}
                            <Grid item xs={12} sm={2.5}>
                                <CMButton
                                    label={aprobandoMasivo ? 'Aprobando...' : `Aprobar Masivamente (${selectedRows.length})`}
                                    variant="contained"
                                    sx={{
                                        marginLeft: '10px',
                                        marginTop: '10px',
                                        backgroundColor: selectedRows.length >= 2 ? '#2e7d32' : undefined,
                                        '&:hover': { backgroundColor: selectedRows.length >= 2 ? '#1b5e20' : undefined }
                                    }}
                                    disabled={selectedRows.length < 2 || aprobandoMasivo}
                                    onClick={handleAprobarMasivo}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12}>
                    <Grid style={{ height: 500, width: '100%', overflowX: 'auto' }}>
                        <DataGrid
                            rows={rowsdata}
                            columns={columns}
                            pageSize={15}
                            rowsPerPageOptions={[15]}
                            loading={loading}
                            pagination
                            rowHeight={50}
                            // ── NUEVO: habilitar checkboxes ──
                            checkboxSelection
                            disableSelectionOnClick
                            getRowId={(row) => row.id_oc_cabecera}
                            onSelectionModelChange={(ids) => setSelectedRows(ids)}
                            selectionModel={selectedRows}
                            sx={{
                                height: "100%",
                                fontSize: 12,
                                "& .MuiDataGrid-window": {
                                    overflowX: 'scroll',
                                    "&::-webkit-scrollbar": { width: "0.4em" },
                                    "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#888" },
                                    "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
                                },
                            }}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    );
};

export default OrdenesPendientesAprobar;